import * as React from "react";

const CENTaxonomyArrowDown: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.7504 9.18804C18.7504 9.4759 18.6405 9.7639 18.4208 9.98328L12.7958 15.6083C12.3563 16.0477 11.6444 16.0477 11.205 15.6083L5.57996 9.98328C5.1405 9.54382 5.1405 8.83191 5.57996 8.39246C6.01941 7.953 6.73132 7.953 7.17078 8.39246L12.0004 13.2222L16.8308 8.39175C17.2703 7.9523 17.9822 7.9523 18.4217 8.39175C18.6414 8.61148 18.7504 8.89976 18.7504 9.18804Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(CENTaxonomyArrowDown);
